__turbopack_context__.v({
  "eyebrow": "ApiDevelopmentServicesCardSection-module__q1s4kq__eyebrow",
  "heading": "ApiDevelopmentServicesCardSection-module__q1s4kq__heading",
  "section": "ApiDevelopmentServicesCardSection-module__q1s4kq__section",
  "title": "ApiDevelopmentServicesCardSection-module__q1s4kq__title",
});
